import { render, staticRenderFns } from "./UsersOfCompany.vue?vue&type=template&id=a68cb3ae&"
import script from "./UsersOfCompany.vue?vue&type=script&lang=js&"
export * from "./UsersOfCompany.vue?vue&type=script&lang=js&"
import style0 from "./UsersOfCompany.vue?vue&type=style&index=0&id=a68cb3ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports